import React from 'react'
import {Button} from '~/src/design-system/Primitives'

export default function SubmitButton({
  children,
  disabled,
}: {
  children: React.ReactNode
  disabled?: boolean
}) {
  return (
    <Button
      fullWidth
      disabled={disabled}
      variant="primary"
      type="submit"
      data-testid="submit-button">
      {children}
    </Button>
  )
}
